

import { useURLs } from "~~/shared/utils/api.urls";
import { NODE_ENV } from "~~/shared/utils/env";

export const getUser = async () => {
  const isAuthenticated = useCookie("isAuthenticated").value;
  if (!isAuthenticated) {
    return false;
  }
  const url = useURLs[NODE_ENV].USER;
  const { data } = await useFetchApi(
    url,
    {
      // Use timestamp in key to force fresh fetch and prevent stale user data
      key: `user-${Date.now()}`,
      method: "GET",
      headers: {
        client_id: useURLs[NODE_ENV].CLIENT_ID,
        client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
        "Content-Type": "application/json",
      },
      retry: 1,
    },
    true
  );
  return data;
};
export const saveUser = async (payload) => {
  const url = useURLs[NODE_ENV].USER;
  const { data } = await useFetchApi(url, {
    key: `${payload}`,
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  },true);
  return data;
};

export const sendContactEmail = async ({ email, message, phone, name }) => {
  const url = useURLs[CLD_ENV].CLD_SEND_CONTACT_EMAIL;
  const data = await useFetch(url, {
    key: email,
    method: "POST",
    body: JSON.stringify({ message, phone, name, email }),
    headers: {
      "Content-Type": "application/json",
    },
    retry: 1,
  });
  return data;
};
export const sendContactEmailServer = async ({
  email,
  message,
  phone,
  name,
  token
}) => {
  const url =  useCldURLs[CLD_ENV].user.send_email;
  // const url = useURLs[CLD_ENV].CLD_SEND_CONTACT_EMAIL;
  const data = await $fetch(url, {
    key: email,
    method: "POST",
    body: JSON.stringify({ message, phone, name, email, token }),
    headers: {
      "Content-Type": "application/json",
    },
    retry: 1,
  });
  console.log("from server http call to email contact", data);
  return data;
};

export const updateUser = async (payload) => {
  const url = useURLs[NODE_ENV].USER;
  const { data } = await useFetchApi(url, {
    key: `${payload}`,
    method: "PATCH",
    body: payload,
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  },true);
  return data;
};

export const updateUserCategories = async (payload) => {
  const url = useURLs[NODE_ENV].USER_CATEGORY;
  const { data } = await useFetchApi(url, {
    key: `${payload}`,
    method: "PATCH",
    body: payload,
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  },true);
  return data;
};

export const updateUserTours = async (payload) => {
  const url = useURLs[NODE_ENV].USER_TOURS;
  const { data } = await useFetchApi(url, {
    key: `${payload}`,
    method: "PATCH",
    body: payload,
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  },true);
  return data;
};

export const getAvailableLicenses = async () => {
  const url = useURLs[NODE_ENV].USER_LICENSES;
  const { data } = await useFetchApi(url, {
    key: "availableLicenses",
    method: "GET",
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  }, true);
  return data;
};

export const getAvailableBrands = async () => {
  const url = useURLs[NODE_ENV].USER_BRANDS;
  const { data } = await useFetchApi(url, {
    key: "availableBrands",
    method: "GET",
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  }, true);
  return data;
};

export const updateUserLicenses = async (payload) => {
  const url = useURLs[NODE_ENV].USER_LICENSES_UPDATE;
  const { data } = await useFetchApi(url, {
    key: `${payload}`,
    method: "PATCH",
    body: payload,
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  }, true);
  return data;
};

export const updateUserBrands = async (payload) => {
  const url = useURLs[NODE_ENV].USER_BRANDS_UPDATE;
  const { data } = await useFetchApi(url, {
    key: `${payload}`,
    method: "PATCH",
    body: payload,
    headers: {
      client_id: useURLs[NODE_ENV].CLIENT_ID,
      client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
      "Content-Type": "application/json",
    },
    retry: 1,
  }, true);
  return data;
};

export const getCldUser = async () => {
  try {
    const url = useCldURLs[CLD_ENV].user.profile;
    const { data } = await useFetchApi(
      url,
      {
        // Use timestamp in key to force fresh fetch and prevent stale user data
        key: `CLD_USER-${Date.now()}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        retry: 1,
      }, true);

    return data;
  } catch (error) {
    console.log("error", error);
  }
  return false;
};

export const getCldContactData = async () => {
  try {
    
    const url = useCldURLs[CLD_ENV].user.get_contacts;
    const { data } = await useFetchApi(
      url,
      {
        // Use timestamp in key to force fresh fetch and prevent stale data
        key: `CLD_CONTACTS_USER-${Date.now()}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        retry: 1,
      }, true);

    return data;
  } catch (error) {
    console.log("error", error);
  }
  return false;
};
export const updateUserEmails = async (payload) => {
  try {
    const url = useCldURLs[CLD_ENV].user.email;
    const { data } = await useFetchApi(
      url,
      {
        key: `CLD_UPDATE_EMAILS`,
        method: "PUT",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
        retry: 1,
      },
      true
    );

    return data;
  } catch (error) {
    console.log("error", error);
  }
  return false;
};

export const getIsPurchaseOrderRequired = async () => {
  try {
    const url = useCldURLs[CLD_ENV].order.is_po_req;
    const { data } = await useFetchApi(url, {
      key: `IS_PO_Required`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      retry: 1,
    },true);

    return data;
  } catch (error) {
    console.log("error getting PO", error);
  }
  return false;
};

export const getCliSetting = async () => {
  const url = useCldURLs[CLD_ENV].user.cli_setting;
  const { data } = await useFetchApi(url, {
    key: `CLD_CLI_SETTING_${Date.now()}`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    retry: 1,
  }, true);
  return data;
};

export const updateCliSetting = async (payload) => {
  const url = useCldURLs[CLD_ENV].user.cli_setting;
  const { data } = await useFetchApi(url, {
    key: `CLD_CLI_SETTING_UPDATE_${Date.now()}`,
    method: "PUT",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
    retry: 1,
  }, true);
  return data;
};
